import { render } from "./PriceRange.vue?vue&type=template&id=c178cab2&scoped=true"
import script from "./PriceRange.vue?vue&type=script&lang=js"
export * from "./PriceRange.vue?vue&type=script&lang=js"

import "./PriceRange.vue?vue&type=style&index=0&id=c178cab2&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c178cab2"]])

export default __exports__